import Swiper from 'swiper';

class ResponsiveSwiper {
  constructor(
    el,
    wWidth,
    options = {
      slidesPerView: 'auto',
      speed: 500,
    },
    breakpoint = 768
  ) {
    this.wWidth = wWidth;
    this.$block = $(el);
    this.$swiper = this.$block.hasClass('swiper')
      ? this.$block
      : this.$block.find('.swiper');
    this.instance = null;
    this.options = options;
    this.breakpoint = breakpoint;

    this.init();
  }

  init() {
    if (this.wWidth < this.breakpoint) {
      this.instance = new Swiper(this.$swiper[0], this.options);
    }
  }

  destroy() {
    if (this.instance) {
      this.instance.destroy(true, true);
      this.instance = null;
    }
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.destroy();
    this.init();
  }
}

export default ResponsiveSwiper;
